export default "__VITE_ASSET__Ddld7mu4__"